import { DatePivotParams } from "../entities/date_pivot_params";

export const paramsToTransformArgs = <
  T extends DatePivotParams = DatePivotParams,
>(
  params: T
): Record<
  string,
  string | string[] | Date | [string, string, string[] | string][] | null
> => {
  return {
    date_field: params.dateHierarchy,
    value_field: params.measure ?? null,
    group_by_fields: params.segments ?? [],
    min_date: params.minDate,
    max_date: params.maxDate,
    filters: params.filters,
  };
};
